import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-link-broken.tsx
/**
* icon.24.link-broken
*
* Keywords: unlink, disconnect, chain, break, separation, detach, remove, slash
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTguMTExIDExLjY0OGEuNS41IDAgMCAxIC43MDguNzA3bC0xLjIzMiAxLjIzMmEyIDIgMCAwIDAgMi44MjggMi44MjhsMS4yMzItMS4yMzJhLjUuNSAwIDAgMSAuNzA3LjcwN2wtMS4yMzIgMS4yMzJBMyAzIDAgMCAxIDYuODggMTIuODh6TTYuMTQ3IDYuMTQ3YS41LjUgMCAwIDEgLjYyOS0uMDY1bC4wNzguMDY1IDExIDExIC4wNjQuMDc4YS41LjUgMCAwIDEtLjY5My42OTNsLS4wNzgtLjA2NC0xMS0xMS0uMDY1LS4wNzhhLjUuNSAwIDAgMSAuMDY1LS42M202Ljg0NC42MjdhMyAzIDAgMCAxIDQuMjM4IDQuMjM3bC0uMTA3LjExMS0xLjIzMiAxLjIzM2EuNS41IDAgMCAxLS43MDctLjcwN2wxLjIzMi0xLjIzMy4xMzgtLjE1MWEyLjAwMiAyLjAwMiAwIDAgMC0yLjgxNS0yLjgxNWwtLjE1LjEzOC0xLjIzMyAxLjIzMmEuNS41IDAgMCAxLS43MDctLjcwN0wxMi44OCA2Ljg4eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-5084
*/
const Icon24LinkBroken = memo(function Icon24LinkBroken(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M8.111 11.648a.5.5 0 0 1 .708.707l-1.232 1.232a2 2 0 0 0 2.828 2.828l1.232-1.232a.5.5 0 0 1 .707.707l-1.232 1.232A3 3 0 0 1 6.88 12.88zM6.147 6.147a.5.5 0 0 1 .629-.065l.078.065 11 11 .064.078a.5.5 0 0 1-.693.693l-.078-.064-11-11-.065-.078a.5.5 0 0 1 .065-.63m6.844.627a3 3 0 0 1 4.238 4.237l-.107.111-1.232 1.233a.5.5 0 0 1-.707-.707l1.232-1.233.138-.151a2.002 2.002 0 0 0-2.815-2.815l-.15.138-1.233 1.232a.5.5 0 0 1-.707-.707L12.88 6.88z"
		})
	});
});
//#endregion
export { Icon24LinkBroken };

//# sourceMappingURL=icon-24-link-broken.js.map